export default {
  install(Vue) {
    Vue.prototype.$config = Vue.observable({
      app_name: "Booking-engine",
      server_url: process.env.VUE_APP_BACKEND,
      app_version: "1.1.0"
    });
  }
};
